import { Calendar } from '../map/Calendar'
import { CalendarTravelEntry } from '../map/CalendarTravelEntry'

export class DriverTableEntry {
  constructor ({ calendar = {}, loading = true } = {}) {
    this.calendar = new Calendar(calendar)
    this.currentCalendarTravel = new CalendarTravelEntry()
    this.selectedDate = ''
    this.loading = true
  }

  get isEmpty () {
    return this.selectedDate === ''
  }

  getTravels (id) {
    return this.calendar.getTravelsByUser(this.selectedDate, id)
  }
}
